import { Box, IconButton, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import React from 'react'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const primary = blue[300];

export default function NotFoundPage() {
  return (
    <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: primary,
    }}
  >
    <Typography variant="h1" style={{ color: 'white' }}>
      404
    </Typography>
    <IconButton>
      <SentimentVeryDissatisfiedIcon sx={{ fontSize: 100, color: 'lightgray' }}/>
    </IconButton>
  </Box>
  )
}
